import { jsx as _jsx } from "react/jsx-runtime";
import { MacroButton } from '../components/MacroButton';
import { useAppSelector } from '../hooks';
import { allMacros } from '../features/macros/macrosSlice';
export const Macros = (_props) => {
    const macros = useAppSelector(state => allMacros(state.definitions.macros));
    const macrosElems = [];
    for (const macro of macros) {
        if (macro && macro.active) {
            macrosElems.push(_jsx(MacroButton, { id: macro.id }, macro.id));
        }
    }
    return (_jsx("div", { className: "page-container", children: _jsx("div", { className: "macros", children: macrosElems }) }));
};
